import {
  createContext,
  FC,
  ReactElement,
  useCallback,
  useContext,
  useState,
} from 'react'

const SettingsContext = createContext<{
  handleRoute: (data: any) => void
  routeInfo: any
}>({
  handleRoute: () => new Promise<null>(() => null),
  routeInfo: {},
})

export const useSettings = () => useContext(SettingsContext)

export const SettingsProvider: FC<{ children: ReactElement }> = ({
  children,
}) => {
  const [routeInfo, setRouteInfo] = useState(null)

  const handleRoute = useCallback(async (path) => {
    try {
      setRouteInfo(path)
    } catch (error) {}
  }, [])

  return (
    <SettingsContext.Provider
      value={{
        routeInfo,
        handleRoute,
      }}
    >
      {children}
    </SettingsContext.Provider>
  )
}
